export default __webpack_public_path__ + "static/media/reward_header_image.4908bfac.png";